import {

    Box,

    Button,

    Typography

} from "@mui/material";

import useAuth from "../hooks/useAuth";

export default function Dashboard() {

    const {

        user,

        logout

    } = useAuth();

    return (

        <Box sx={{ p: 5 }}>

            <Typography variant="h3">

                Dashboard

            </Typography>

            <Typography sx={{ mt: 3 }}>

                Welcome

                {" "}

                {user?.name}

            </Typography>

            <Typography>

                {user?.email}

            </Typography>

            <Typography>

                {user?.role}

            </Typography>

            <Button

                variant="contained"

                sx={{ mt: 4 }}

                onClick={logout}

            >

                Logout

            </Button>

        </Box>

    );

}